import * as React from 'react';

import { IconPropsType } from 'designSystem/types/icons';

interface IBackButtonIconProps extends IconPropsType {}

const BackButtonIcon = ({
  size = 32,
  color = '#ffffff',
  ...props
}: IBackButtonIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_1537_8850)">
      <path
        d="M21.5 16H10.5"
        stroke={color}
        strokeWidth={1.3}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 11.5L10.5 16L15 20.5"
        stroke={color}
        strokeWidth={1.3}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1537_8850">
        <rect width={16} height={16} fill="white" transform="translate(8 8)" />
      </clipPath>
    </defs>
  </svg>
);
export default BackButtonIcon;
